const translations: Record<string, string> = {
  // Navbar
  "nav.home": "Главная",
  "nav.about": "О нас",
  "nav.services": "Услуги",
  "nav.news": "Новости",
  "nav.partner": "Стать партнёром",
  "nav.cta": "Зарегистрироваться как заявитель",
  "nav.partnerAccess": "Partner Access",

  // Hero
  "hero.label": "Публичный консультационный центр — Республика Молдова",
  "hero.title1": "EU Next Grants",
  "hero.title2": "Консультации & Поддержка проектов",
  "hero.subtitle": "Мы помогаем молдавским НКО и гражданским организациям находить, подавать заявки и успешно реализовывать европейское и международное грантовое финансирование — от первого объявления до финального отчёта.",
  "hero.cta1": "Зарегистрироваться как заявитель",
  "hero.cta2": "Наши услуги",
  "hero.scroll": "Прокрутить",

  // About Preview
  "aboutPreview.label": "О EU Next Grants",
  "aboutPreview.title": "Ваш надёжный консультационный партнёр по грантам ЕС в Молдове",
  "aboutPreview.p1": "EU Next Grants — публичный консультационный центр, созданный для устранения разрыва между гражданским обществом Молдовы и возможностями европейского финансирования. Мы обеспечиваем полный цикл поддержки — от поиска грантов и оценки соответствия до написания заявок и надзора за реализацией проектов.",
  "aboutPreview.p2": "В нашу команду входят сертифицированные грант-менеджеры, специалисты по политике ЕС и профессионалы в области управления проектами с более чем десятилетним совокупным опытом работы с программами, финансируемыми ЕС, в Восточной Европе.",
  "aboutPreview.link": "Узнать больше о нас",
  "aboutPreview.stat1.number": "",
  "aboutPreview.stat1.label": "НКО поддержано",
  "aboutPreview.stat2.number": "",
  "aboutPreview.stat2.label": "Грантов получено",
  "aboutPreview.stat3.number": "",
  "aboutPreview.stat3.label": "Программ ЕС",

  // Services Preview
  "servicesPreview.label": "Что мы делаем",
  "servicesPreview.title": "Полный цикл поддержки грантов — от идеи до реализации",
  "servicesPreview.viewAll": "Все 7 услуг",
  "servicesPreview.explore": "Посмотреть все услуги",
  "servicesPreview.s01.title": "Поиск & картирование грантов",
  "servicesPreview.s01.desc": "Мы сканируем и картируем открытые конкурсы ЕС и других крупных доноров, предоставляя вашей организации персонализированную картину возможностей финансирования.",
  "servicesPreview.s02.title": "Оценка соответствия критериям",
  "servicesPreview.s02.desc": "Прежде чем тратить ресурсы, мы тщательно проверяем соответствие вашей организации требованиям донора, снижая риск дисквалификации.",
  "servicesPreview.s03.title": "Написание & рецензирование заявок",
  "servicesPreview.s03.desc": "Наши эксперты разрабатывают убедительные и соответствующие требованиям грантовые заявки. Мы также предлагаем независимую экспертизу и контроль качества заявок, подготовленных вашей командой.",
  "servicesPreview.s04.title": "Разработка бюджета & финансовое планирование",
  "servicesPreview.s04.desc": "Мы структурируем бюджеты проектов, которые реалистичны, полностью обоснованы и соответствуют правилам приемлемости затрат донора.",

  // Who We Work With
  "whoWeWork.label": "С кем мы работаем",
  "whoWeWork.title": "Поддерживаем экосистему гражданского общества Молдовы",
  "whoWeWork.p": "Мы работаем с широким кругом организаций гражданского общества Молдовы — от низовых общественных организаций до крупных НКО с международными партнёрствами. Независимо от того, подаёте ли вы заявку на первый грант или расширяете многолетнюю программу ЕС, мы обеспечиваем индивидуальную поддержку на каждом этапе.",
  "whoWeWork.cta": "Начать разговор",
  "whoWeWork.supportLabel": "Мы поддерживаем",
  "whoWeWork.p1": "Зарегистрированные НКО & ассоциации",
  "whoWeWork.p2": "Местные органы власти",
  "whoWeWork.p3": "Общественные фонды",
  "whoWeWork.p4": "Культурные & Heritage-учреждения",
  "whoWeWork.p5": "Молодёжные & гражданские организации",
  "whoWeWork.p6": "Исследовательские & образовательные учреждения",

  // News Preview
  "newsPreview.label": "Последнее от EU Next Grants",
  "newsPreview.title": "Новости & Грантовые конкурсы",
  "newsPreview.viewAll": "Все обновления",
  "newsPreview.deadline": "Срок подачи:",
  "newsPreview.seeAll": "Смотреть все {{count}} обновления",

  // Contact
  "contact.label": "Связаться с нами",
  "contact.title": "Начните свой грантовый путь сегодня",
  "contact.p": "Свяжитесь с нами для бесплатной первичной консультации. Наши специалисты изучат профиль вашей организации и порекомендуют наиболее подходящие возможности финансирования.",
  "contact.address": "Str. Maria Cebotari 37, Кишинёв, Молдова",
  "contact.emailLabel": "info@eunextgrants.md",
  "contact.phone": "+373 22 000 000",
  "contact.hours": "Пн – Пт: 09:00 – 18:00",
  "contact.form.nameLabel": "Полное имя *",
  "contact.form.emailLabel": "Адрес электронной почты *",
  "contact.form.orgLabel": "Организация",
  "contact.form.messageLabel": "Сообщение *",
  "contact.form.messageNote": "(макс. 500 символов)",
  "contact.form.namePlaceholder": "Ваше полное имя",
  "contact.form.emailPlaceholder": "ваш@email.com",
  "contact.form.orgPlaceholder": "Название вашей НКО или учреждения",
  "contact.form.messagePlaceholder": "Кратко опишите вашу организацию и какая поддержка вам нужна...",
  "contact.form.submit": "Отправить сообщение",
  "contact.form.sending": "Отправка...",
  "contact.form.error": "Что-то пошло не так. Пожалуйста, попробуйте ещё раз.",
  "contact.success.title": "Сообщение получено",
  "contact.success.p": "Спасибо за обращение. Член нашей команды свяжется с вами в течение одного рабочего дня.",
  "contact.success.again": "Отправить ещё одно сообщение",

  // About Page
  "about.hero.label": "О нас",
  "about.hero.title": "Кто мы и что нами движет",
  "about.mission.label": "Наша миссия",
  "about.mission.title": "Демократизация доступа к европейскому финансированию",
  "about.mission.p1": "EU Next Grants была основана на простом убеждении: каждая молдавская НКО с подлинной социальной миссией заслуживает равного доступа к финансированию ЕС и международным грантам — независимо от размера, языкового потенциала или предыдущего опыта работы с европейской бюрократией.",
  "about.mission.p2": "Мы функционируем как публичный консультационный центр, а не как коммерческое агентство. Наша тарифная политика рассчитана на доступность для начинающих организаций, а мы регулярно оказываем бесплатные консультационные услуги общественным группам в неблагополучных регионах.",
  "about.mission.p3": "Наш подход носит институциональный характер — строгий, тщательный и основанный на глубоком знании циклов программирования ЕС, требований соответствия и стандартов оценки воздействия.",
  "about.stats.s1": "НКО поддержано",
  "about.stats.s2": "Грантов получено",
  "about.stats.s3": "Активных программ",
  "about.history.label": "Наша история",
  "about.history.title": "Десятилетие гражданского воздействия",
  "about.milestone.2014": "Основан в Кишинёве как гражданская консультационная инициатива",
  "about.milestone.2016": "Первый крупный портфель проектов EU4Moldova — €1,2 млн привлечено",
  "about.milestone.2019": "Стали аккредитованным партнёром Делегации Европейской комиссии в Молдове",
  "about.milestone.2021": "Расширили услуги, охватив гранты GIZ, USAID и Совета Европы",
  "about.milestone.2023": "Превысили €8 млн в общем объёме привлечённых грантов для гражданского общества Молдовы",
  "about.milestone.2025": "Запустили Moldova NGO Grant Navigator — открытый ресурсный портал",
  "about.team.label": "Наша команда",
  "about.team.title": "Старшие специалисты, реальный опыт",
  "about.team.0.name": "Елена Морару",
  "about.team.0.role": "Директор-основатель & Старший грантовый советник",
  "about.team.0.bio": "15 лет опыта в управлении проектами, финансируемыми ЕС. Бывший советник Министерства европейской интеграции Молдовы. Сертифицированный менеджер проектов ЕС (IPMA уровень B).",
  "about.team.1.name": "Андрей Кожокару",
  "about.team.1.role": "Руководитель отдела разработки заявок",
  "about.team.1.bio": "Руководил более чем 60 успешными грантовыми заявками в рамках Horizon Europe, Erasmus+ и EU4Moldova. Специалист по проектированию логической структуры и нарративному письму.",
  "about.team.2.name": "Наталья Русу",
  "about.team.2.role": "Специалист по финансовому соответствию",
  "about.team.2.bio": "Экспертиза в области бюджетных правил ЕС, приемлемости затрат и подготовки к аудиту. Прошла обучение в Европейском суде аудиторов и в рамках антифрод-системы OLAF.",
  "about.values.label": "Наши ценности",
  "about.values.title": "Принципиально. Прозрачно. Эффективно.",
  "about.values.0.title": "Независимость",
  "about.values.0.desc": "Мы работаем без политических или коммерческих интересов, обеспечивая, что наши советы всегда в ваших интересах.",
  "about.values.1.title": "Прозрачность",
  "about.values.1.desc": "Чёткое ценообразование, открытое общение и полное раскрытие наших методологий и ограничений.",
  "about.values.2.title": "Превосходство",
  "about.values.2.desc": "Мы придерживаемся тех же стандартов, что и программные офицеры ЕС — строгих, основанных на доказательствах и ориентированных на результат.",
  "about.values.3.title": "Доступность",
  "about.values.3.desc": "Поддержка грантов не должна быть привилегией крупных учреждений. Мы активно работаем над выравниванием условий.",

  // Services Page
  "services.hero.label": "Наши услуги",
  "services.hero.title": "Комплексная поддержка грантов — от первого объявления до финального отчёта",
  "services.core.label": "Основные услуги",
  "services.core.title": "Семь областей специализированной поддержки",
  "services.s01.title": "Поиск грантов & картирование возможностей финансирования",
  "services.s01.desc": "Мы проводим всестороннее сканирование всех актуальных открытых конкурсов ЕС, Совета Европы и других крупных доноров, активных в Молдове. Вы получаете персонализированную матрицу финансирования — адаптированную к вашему сектору, масштабу и стратегическим приоритетам.",
  "services.s02.title": "Оценка соответствия & предварительный анализ",
  "services.s02.desc": "До привлечения каких-либо ресурсов мы проводим детальную проверку соответствия всем критериям донора — правовой статус, тематическая направленность, географический охват, требования к софинансированию и финансовые пороги — снижая риск административного отказа.",
  "services.s03.title": "Написание заявок & техническая помощь",
  "services.s03.desc": "Наши старшие авторы разрабатывают полные, убедительные и полностью соответствующие требованиям грантовые заявки — включая нарратив, логическую структуру, план работ, матрицу рисков и методологию оценки. Мы также предлагаем независимое рецензирование и контроль качества заявок, разработанных вашей командой.",
  "services.s04.title": "Разработка бюджета & финансовое планирование",
  "services.s04.desc": "Мы структурируем реалистичные, сбалансированные и полностью обоснованные бюджеты проектов в соответствии с правилами приемлемости затрат донора. Это включает расчёты затрат на персонал, учёт косвенных расходов, оценку натуральных взносов и распределение бюджета партнёров.",
  "services.s05.title": "Развитие партнёрств & формирование консорциумов",
  "services.s05.desc": "Многие гранты ЕС требуют консорциумов. Мы помогаем в поиске и привлечении подходящих партнёров — в Молдове и за рубежом — и содействуем в переговорах о партнёрских соглашениях, определении ролей и обеспечении чёткого управления в рамках консорциума.",
  "services.s06.title": "Поддержка реализации проекта",
  "services.s06.desc": "После получения финансирования мы обеспечиваем практическую поддержку реализации: системы мониторинга и оценки, руководство по закупкам, шаблоны финансовой отчётности, составление отчётов о ходе работ и коммуникацию с программными офицерами от вашего имени.",
  "services.s07.title": "Наращивание потенциала & обучение работе с грантами",
  "services.s07.desc": "Мы проводим специализированные тренинги для сотрудников НКО — охватывающие архитектуру грантов ЕС, навыки написания заявок, финансовое управление по правилам ЕС и процедуры закупок PRAG. Доступны как групповые семинары или индивидуальные менторские программы.",
  "services.lots.label": "Тематические области",
  "services.lots.title": "Тематические лоты грантов",
  "services.lots.p": "Наша консультационная работа организована вокруг пяти тематических лотов, согласованных с приоритетными программными областями ЕС для Восточного партнёрства и Молдовы в частности.",
  "services.lot1.lot": "Лот 1",
  "services.lot1.title": "Демократия, управление & верховенство права",
  "services.lot1.desc": "Гражданское участие, антикоррупция, судебная реформа, избирательная честность и модернизация государственного управления.",
  "services.lot2.lot": "Лот 2",
  "services.lot2.title": "Права человека & социальная инклюзия",
  "services.lot2.desc": "Гендерное равенство, права инвалидов, поддержка беженцев и миграция, интеграция ромов и доступ к правосудию.",
  "services.lot3.lot": "Лот 3",
  "services.lot3.title": "Окружающая среда, климат & зелёный переход",
  "services.lot3.desc": "Охрана окружающей среды, адаптация к климату, устойчивая энергетика, управление отходами и биоразнообразие.",
  "services.lot4.lot": "Лот 4",
  "services.lot4.title": "Молодёжь, образование & культурное наследие",
  "services.lot4.desc": "Неформальное образование, молодёжное лидерство, партнёрства Erasmus+, межкультурный диалог и сохранение наследия.",
  "services.lot5.lot": "Лот 5",
  "services.lot5.title": "Местное развитие & экономическая устойчивость",
  "services.lot5.desc": "Сельское развитие, поддержка МСП и кооперативов, социальное предпринимательство, диверсификация местной экономики.",
  "services.cta.label": "Готовы подать заявку?",
  "services.cta.title": "Найдём подходящий грант для вашей организации",
  "services.cta.p": "Запишитесь на бесплатную 30-минутную консультацию с одним из наших грантовых специалистов. Без каких-либо обязательств.",
  "services.cta.btn": "Зарегистрироваться как заявитель",

  // News Page
  "news.hero.label": "Будьте в курсе",
  "news.hero.title": "Новости & Грантовые объявления",
  "news.hero.p": "Открытые конкурсы, результаты проектов, предстоящие мероприятия и обновления о финансировании ЕС, актуальные для гражданского общества Молдовы.",
  "news.cat.all": "Все обновления",
  "news.cat.grant-call": "Открытые конкурсы",
  "news.cat.news": "Новости",
  "news.cat.event": "Мероприятия",
  "news.cat.result": "Результаты проектов",
  "news.search": "Поиск новостей...",
  "news.deadline": "Срок подачи:",
  "news.readMore": "Читать далее",
  "news.latest": "Последние",
  "news.moreUpdates": "Ещё обновления",
  "news.noResults.title": "Результаты не найдены",
  "news.noResults.p": "Попробуйте изменить поисковый запрос или фильтр категории.",
  "news.sub.label": "Оставайтесь в курсе",
  "news.sub.title": "Не пропустите ни одного открытого грантового конкурса",
  "news.sub.p": "Мы отправляем краткий ежемесячный дайджест наиболее актуальных возможностей грантов ЕС и международных грантов для молдавских НКО.",
  "news.sub.btn": "Запросить грантовый дайджест",

  // Register NGO Page
  "register.hero.label": "Сеть партнёров",
  "register.hero.title": "Зарегистрируйте вашу НКО как партнёра",
  "register.hero.p": "Присоединяйтесь к растущей молдавской сети организаций гражданского общества, готовых к грантам ЕС. Регистрация бесплатна и обеспечивает вашей НКО приоритетный доступ к нашим консультационным услугам и информации о финансировании.",
  "register.why.label": "Зачем регистрироваться?",
  "register.why.title": "Что получают партнёрские НКО",
  "register.privacy": "Данные регистрации используются исключительно в целях координации партнёрства и не передаются третьим лицам. Вся информация обрабатывается в соответствии с требованиями GDPR ЕС.",
  "register.form.label": "Форма регистрации",
  "register.benefit.0.title": "Доступ к нашей базе грантов",
  "register.benefit.0.desc": "Получайте ежемесячные подборки открытых конкурсов, подходящих для вашего сектора и возможностей.",
  "register.benefit.1.title": "Приоритетная поддержка заявок",
  "register.benefit.1.desc": "Партнёрские НКО получают ускоренный доступ к нашим услугам по написанию и рецензированию заявок.",
  "register.benefit.2.title": "Подбор в консорциумы",
  "register.benefit.2.desc": "Мы активно подбираем зарегистрированным партнёрам возможности участия в консорциумах ЕС по их тематическому направлению.",
  "register.benefit.3.title": "Обучение & наращивание потенциала",
  "register.benefit.3.desc": "Эксклюзивный доступ к грантовым семинарам, вебинарам и индивидуальным менторским сессиям.",

  // Registration Form
  "form.section.org": "Сведения об организации",
  "form.section.projects": "Реализованные проекты",
  "form.section.contact": "Контактное лицо",
  "form.org.name.label": "Полное официальное название организации *",
  "form.org.name.placeholder": "напр. Ассоциация гражданского развития",
  "form.org.field.label": "Сфера деятельности *",
  "form.org.field.placeholder": "Выберите сферу...",
  "form.org.address.label": "Юридический адрес *",
  "form.org.address.placeholder": "Улица, Город, Район",
  "form.org.phone.label": "Номер телефона *",
  "form.org.phone.placeholder": "+373 XX XXX XXX",
  "form.org.email.label": "Институциональный e-mail *",
  "form.org.email.placeholder": "contact@yourorg.md",
  "form.projects.note": "Перечислите от 3 до 5 проектов, реализованных вашей организацией. Укажите название проекта, донора и краткий результат (макс. 300 символов на каждый).",
  "form.projects.label": "Проект {{n}}",
  "form.projects.optional": "(необязательно)",
  "form.projects.placeholder": "Название проекта / Год реализации",
  "form.projects.add": "Добавить ещё один проект ({{n}}/5)",
  "form.contact.name.label": "Полное имя *",
  "form.contact.name.placeholder": "Имя, Фамилия",
  "form.contact.role.label": "Должность / Позиция *",
  "form.contact.role.placeholder": "напр. Исполнительный директор, Менеджер проекта",
  "form.submit": "Подать заявку на партнёрство",
  "form.submitting": "Отправка...",
  "form.error": "Что-то пошло не так. Пожалуйста, проверьте данные и попробуйте снова.",
  "form.success.title": "Заявка отправлена",
  "form.success.p": "Спасибо за регистрацию. Наша команда изучит профиль вашей организации и свяжется с вами в течение 3 рабочих дней.",
  "form.success.again": "Подать ещё одну заявку",
  "form.activity.democracy": "Демократия & Гражданское управление",
  "form.activity.humanrights": "Права человека & Верховенство права",
  "form.activity.environment": "Окружающая среда & Зелёный переход",
  "form.activity.youth": "Молодёжь, Образование & Неформальное обучение",
  "form.activity.social": "Социальная инклюзия & Развитие сообщества",
  "form.activity.gender": "Гендерное равенство & Расширение прав женщин",
  "form.activity.culture": "Культура, Наследие & Творческие искусства",
  "form.activity.media": "Медиа, Журналистика & Свобода слова",
  "form.activity.health": "Здравоохранение & Социальные услуги",
  "form.activity.economic": "Местное экономическое развитие",
  "form.activity.research": "Исследования & Гражданские технологии",
  "form.activity.other": "Другое",

  // Article Page
  "article.notFound.title": "Статья не найдена",
  "article.notFound.p": "Статья, которую вы ищете, не существует или была удалена.",
  "article.notFound.back": "Назад к новостям",
  "article.back": "Назад к новостям",
  "article.deadline": "Срок подачи:",
  "article.cta.title": "Нужна помощь с этой заявкой?",
  "article.cta.p": "Наши грантовые специалисты могут оценить вашу правомочность и поддержать вашу заявку на данный конкурс.",
  "article.cta.btn": "Получить бесплатную консультацию",
  "article.sidebar.info": "Ключевая информация",
  "article.sidebar.deadline": "Срок подачи",
  "article.sidebar.published": "Опубликовано",
  "article.sidebar.source": "Источник",
  "article.sidebar.category": "Категория",
  "article.related": "Похожие статьи",
  "article.allNews": "Все новости & обновления",
  "article.tags": "Теги",

  // Footer
  "footer.tagline": "Помогаем гражданскому обществу Молдовы получить доступ к европейскому и международному грантовому финансированию.",
  "footer.rights": "Все права защищены.",
};

export default translations;
